'use strict';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ICurationItem } from '../../../../interfaces/curation-item.interface';
import { CurationEditorHelper } from '../../curation-editor-helper';
import { CurationUtils } from '../../../../utils/curation-utils';

const USER_CREATED_TAG = 'Pubmed_UserCreated';

@Component({
  selector: 'gen-curation-editor-aberration-data',
  templateUrl: 'curation-editor-aberration-data.component.html',
  styleUrls: ['curation-editor-aberration-data.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class CurationEditorAberrationDataComponent implements OnInit {
  @Output() validated: EventEmitter<any> = new EventEmitter();
  @Output() itemDeleted: EventEmitter<any> = new EventEmitter();
  @Output() aberrationDataChanged: EventEmitter<any> = new EventEmitter();
  @Input() aberrationDetailsFormName: string;
  @Input() readOnly: boolean;
  @Input() inlineEdit: boolean = false;
  @Input() diagnosticFormName: string;
  @Input() prognosticFormName: string;
  @Input() therapeuticFormName: string;
  @Input() clinicalTrialsFormName: string;
  @Input() casesFormName: string;
  @Input() summaryFormName: string;
  @Input() pubmedFormName: string;
  @Input() prioritizeAvailable = false;
  @Input() submitted: boolean = false;
  @Input() approvedMode: boolean = false;
  @Input() revisionTag: string;
  @Input() verticalForm: boolean;
  @Input() searchDataConfigParams: any;
  @Input() googleSearchURL: string;
  @Input() pubmedSearchURL: string;

  public _curationItem: ICurationItem;
  public revisionId: string;
  public userCreatedTagPrefix: string = USER_CREATED_TAG;
  public casesRootName: string = CurationEditorHelper.CASES_ROOT;
  public clinicalTrialsRootName: string = CurationEditorHelper.CLINICAL_TRIALS_ROOT;
  public pubMedLink: string;
  public googleLink: string;

  @Input() set curationKey(key: string) {
    this.googleLink = 'https://www.google.com/search?q=' + key;
    this.pubMedLink = 'https://www.ncbi.nlm.nih.gov/pubmed/?term=' + key;
  }

  @Input() set curationItem(item: ICurationItem) {
    if (item) {
      this._curationItem = item;
    }
  }

  constructor() { }

  ngOnInit() {
  }

  validationEvent($event) {
    this.validated.emit($event);
  }

  pubmedUpdate(pubmedsList: any) {
      this._curationItem.curationData['manualAnnotations'].pubmedsLinks = pubmedsList;
  }

  deleteItem($event) {
    this.itemDeleted.emit($event);
  }

  aberrationDataChangedEvent($event) {
    this.aberrationDataChanged.emit($event);
  }
}
